module.exports = __webpack_public_path__ + "img/汉熵指挥调度管理平台.ad61706b.png";